<script lang="ts">
  import Select from 'svelte-select/Select.svelte';
  import { identifyDealership } from '../../../lib/services/pdf/identifyDealership';
  import { fly } from 'svelte/transition';
  import { _ } from 'svelte-i18n';

  let backEndUrl = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbdmbos`;

  export let dealershipInfo: any;
  export let dealer: string = '';
  export let dealershipLocation: string = '';
  export let showDealershipDropdown: boolean = false;
  export let zipCode: string = '';
  let showList = false;
  let listOpen = false;

  let disableDealershipDropdown = true;

  $: dealershipLabel = dealershipInfo ? dealershipInfo.label : '';

  let allDealers: { value: number; vfnr: string; label: string }[] = [];

  fetch(`${backEndUrl}/dealerships`, {
    headers: {
      Accept: 'application/json, text/plain',
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Custom-Header': 'mb-cashback-2025-header',
    },
  }).then((response) => {
    response.json().then((dealerships) => {
      allDealers = dealerships.map((dealer: any) => {
        return {
          value: dealer.id,
          vfnr: response.vfnr,
          // label: `${dealer.id} | ${dealer.name} | ${dealer.strasse} | ${dealer.plz}| ${dealer.ort}`,
          label: `${dealer.name} | ${dealer.vfnr} | ${dealer.strasse} | ${dealer.plz}| ${dealer.ort}`,
        };
      });
    });
  });

  $: {
    identifyDealership(dealer, dealershipLocation, zipCode).then((response) => {

      if (response) {

        dealershipInfo = {
          value: response.id,
          vfnr: response.vfnr,
          // label: `${response.id} | ${response.name} | ${response.strasse} | ${response.plz}| ${response.ort}`,
          label: `${response.name} | ${response.vfnr} | ${response.strasse} | ${response.plz}| ${response.ort}`,        };
      }
    });
  }

</script>

{#if allDealers.length > 0}
  {#if showDealershipDropdown}
    <div class="relative">
      <div>
        <input
          disabled={false}
          type="text"
          on:click={() => {
            // open the list and show it
            showList = true;
            listOpen = true;
          }}
          class="form-input w-full cursor-pointer"
          bind:value={dealershipLabel}
          placeholder={$_('Please Select')}
        />
      </div>

      {#if showList}
        <div
          transition:fly|local={{ duration: 200, y: -16 }}
          class="select-container absolute z-50 mt-1 w-[330px] sm:w-[98%]"
        >
          <Select
            items={allDealers}
            {listOpen}
            on:select={(e) => {
              showList = false;
              listOpen = false;

              dealershipInfo = e.detail;
            }}
            placeholder={$_('Search here')}
            on:blur={() => {
              showList = false;
              listOpen = false;
            }}
          >
            <div
              slot="item"
              let:item
              class="select-item-custom cursor-pointer py-2"
            >
              <span class="select-item-text">{item.label}</span>
              {#if item.value === dealershipInfo?.value}
                <input
                  type="checkbox"
                  checked={item.value === dealershipInfo?.value}
                  class="checkbox-input select-item-checkbox"
                  readonly
                />
              {/if}
            </div>
          </Select>
        </div>
      {/if}
    </div>
  {:else}
    <div class="form-field !hidden">
      <div class="data-field !hidden" id="hidden-dealer-info">
        {JSON.stringify(dealershipInfo)}
        <div class="relative">
          <div>
            <input
              disabled={false}
              type="text"
              on:click={() => {
                // open the list and show it
                showList = true;
                listOpen = true;
              }}
              class="form-input w-full cursor-pointer"
              bind:value={dealershipLabel}
              placeholder={$_('Please Select')}
            />
          </div>
    
          {#if showList}
            <div
              transition:fly|local={{ duration: 200, y: -16 }}
              class="select-container absolute z-50 mt-1 w-[330px] sm:w-[98%]"
            >
              <Select
                items={allDealers}
                {listOpen}
                on:select={(e) => {
                  showList = false;
                  listOpen = false;

                  dealershipInfo = e.detail;
                }}
                placeholder={$_('Search here')}
                on:blur={() => {
                  showList = false;
                  listOpen = false;
                }}
              >
                <div
                  slot="item"
                  let:item
                  class="select-item-custom cursor-pointer py-2"
                >
                  <span class="select-item-text">{item.label}</span>
                  {#if item.value === dealershipInfo?.value}
                    <input
                      type="checkbox"
                      checked={item.value === dealershipInfo?.value}
                      class="checkbox-input select-item-checkbox"
                      readonly
                    />
                  {/if}
                </div>
              </Select>
            </div>
          {/if}
        </div>
      </div>
    </div>
  {/if}
{/if}
